<script lang="ts">
  import { Router, Route, NotFoundRoute, redirect } from "./utils/pager";
  import { isUserRoleADM, user } from "./app.store";
  import { initialize } from "./app.logic";
  import { get } from "svelte/store";
  import LoginPage from "./pages/Login/LoginPage.svelte";
  import DashboardPage from "./pages/Dashboard/DashboardPage.svelte";
  import ProfilePage from "./pages/Profile/ProfilePage.svelte";
  import NotFoundPage from "./pages/NotFound/NotFoundPage.svelte";
  import UserListPage from "./pages/User/UserListPage.svelte";
  import SettingsPage from "./pages/Settings/SettingsPage.svelte";
  import UserDetailPage from "./pages/User/UserDetailPage.svelte";
  import SectionListPage from "./pages/Section/SectionListPage.svelte";
  import SectionDetailPage from "./pages/Section/SectionDetailPage.svelte";
  import ClassroomListPage from "./pages/Classroom/ClassroomListPage.svelte";
  import ClassroomDetailPage from "./pages/Classroom/ClassroomDetailPage.svelte";
  import ChallengeListPage from "./pages/Challenge/ChallengeListPage.svelte";
  import ChallengeDetailPage from "./pages/Challenge/ChallengeDetailPage.svelte";
  import ChallengeTaskListPage from "./pages/Challenge/ChallengeTaskListPage.svelte";
  import ChallengeTaskDetailPage from "./pages/Challenge/ChallengeTaskDetailPage.svelte";
  import ScorePage from "./pages/Score/ScorePage.svelte";
  import TaskSectionListPage from "./pages/Task/TaskSectionListPage.svelte";
  import SubmissionListPage from "./pages/Submission/SubmissionListPage.svelte";
  import TaskSectionDetailPage from "./pages/Task/TaskSectionDetailPage.svelte";
  import TaskSubmissionGeneralPage from "./pages/Task/TaskSubmissionGeneralPage.svelte";
  import TaskSubmissionSubmissionPage from "./pages/Task/TaskSubmissionSubmissionPage.svelte";
  import TaskSubmissionSubtaskPage from "./pages/Task/TaskSubmissionSubtaskPage.svelte";
  import TaskSubmissionFilesPage from "./pages/Task/TaskSubmissionFilesPage.svelte";
  import SubmissionDetailPage from "./pages/Submission/SubmissionDetailPage.svelte";

  // const data1 = { foo: "bar", custom: true };

  const loginGuard = (_ctx: any, next: any) => {
    // user.subscribe((u) => {
    // console.log("loginGuard user:", u);
    let u = get(user);
    // check if user is authenticated
    if (u === null) {
      // redirect("/login");
      initialize();
    } else {
      // go to the next callback in the chain
      next();
      //redirect("/dashboard");
    }
    // });
  };

  const adminGuard = (_ctx: any, next: any) => {
    let adm = get(isUserRoleADM);
    if (!adm) {
      redirect("/");
    } else {
      next();
    }
  };

  const defaultRouteGuard = (_ctx: any, _next: any) => {
    redirect("/dashboard");
  };

  // onMount(initialize);
</script>

<Router>
  <Route path="/" middleware={[loginGuard, defaultRouteGuard]} component={null}>
    <div class="initial-loader" />
  </Route>
  <Route path="/login" component={LoginPage} />
  <!--
  <Route
    middleware={[loginGuard]}
    path="/profile/:username"
    component={ProfilePage}
  />
  -->
  <!-- <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} data={data1} /> -->
  <Route path="/profile" middleware={[loginGuard]} component={ProfilePage} />
  <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} />
  <Route path="/score" middleware={[loginGuard]} component={ScorePage} />
  <Route path="/task" middleware={[loginGuard]} component={TaskSectionListPage} />
  <Route path="/task/:sectionId" middleware={[loginGuard]} component={TaskSectionDetailPage} />
  <Route path="/task/:sectionId/:challengeId/general" middleware={[loginGuard]} component={TaskSubmissionGeneralPage} />
  <Route path="/task/:sectionId/:challengeId/files" middleware={[loginGuard]} component={TaskSubmissionFilesPage} />
  <Route path="/task/:sectionId/:challengeId/submission" middleware={[loginGuard]} component={TaskSubmissionSubmissionPage} />
  <Route path="/task/:sectionId/:challengeId/submission/:submissionId" middleware={[loginGuard]} component={TaskSubmissionSubtaskPage} />
  <!-- ADMIN -->
  <Route path="/user" middleware={[loginGuard, adminGuard]} component={UserListPage} />
  <Route path="/user/:oid" middleware={[loginGuard, adminGuard]} component={UserDetailPage} />
  <Route path="/section" middleware={[loginGuard, adminGuard]} component={SectionListPage} />
  <Route path="/section/:oid" middleware={[loginGuard, adminGuard]} component={SectionDetailPage} />
  <Route path="/classroom" middleware={[loginGuard, adminGuard]} component={ClassroomListPage} />
  <Route path="/classroom/:oid" middleware={[loginGuard, adminGuard]} component={ClassroomDetailPage} />
  <Route path="/challenge" middleware={[loginGuard, adminGuard]} component={ChallengeListPage} />
  <Route path="/challenge/:oid" middleware={[loginGuard, adminGuard]} component={ChallengeDetailPage} />
  <Route path="/challenge/:challengeId/tasks" middleware={[loginGuard, adminGuard]} component={ChallengeTaskListPage} />
  <Route path="/challenge/:challengeId/tasks/:oid" middleware={[loginGuard, adminGuard]} component={ChallengeTaskDetailPage} />
  <Route path="/submission" middleware={[loginGuard, adminGuard]} component={SubmissionListPage} />
  <Route path="/submission/:oid" middleware={[loginGuard, adminGuard]} component={SubmissionDetailPage} />
  <Route path="/settings" middleware={[loginGuard, adminGuard]} component={SettingsPage} />

  <!--
    <Route
      path="/profile/:username"
      let:params
      middleware={[guard]}
      component={Profile}
    />
    -->
  <NotFoundRoute>
    <NotFoundPage />
  </NotFoundRoute>
</Router>

<!--<style>
  main {
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
  nav a {
    padding-right: 3rem;
  }
</style>-->
